/* tslint:disable */
/* eslint-disable */
/**
 * MINDD SCAN2 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { SensorStatus } from '../model';
// @ts-ignore
import type { Type } from '../model';
/**
 * SensorControllerApi - axios parameter creator
 * @export
 */
export const SensorControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} deviceSerial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorStatus: async (deviceSerial: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceSerial' is not null or undefined
            assertParamExists('getSensorStatus', 'deviceSerial', deviceSerial)
            const localVarPath = `/sensors/{deviceSerial}/status`
                .replace(`{${"deviceSerial"}}`, encodeURIComponent(String(deviceSerial)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} deviceSerial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startRecording: async (deviceSerial: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceSerial' is not null or undefined
            assertParamExists('startRecording', 'deviceSerial', deviceSerial)
            const localVarPath = `/sensors/{deviceSerial}/recording/start`
                .replace(`{${"deviceSerial"}}`, encodeURIComponent(String(deviceSerial)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} deviceSerial 
         * @param {Type} sensorType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startTransmission: async (deviceSerial: string, sensorType: Type, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceSerial' is not null or undefined
            assertParamExists('startTransmission', 'deviceSerial', deviceSerial)
            // verify required parameter 'sensorType' is not null or undefined
            assertParamExists('startTransmission', 'sensorType', sensorType)
            const localVarPath = `/sensors/{deviceSerial}/{sensorType}/transmission/start`
                .replace(`{${"deviceSerial"}}`, encodeURIComponent(String(deviceSerial)))
                .replace(`{${"sensorType"}}`, encodeURIComponent(String(sensorType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} deviceSerial 
         * @param {Type} sensorType 
         * @param {boolean} save 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopRecording: async (deviceSerial: string, sensorType: Type, save: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceSerial' is not null or undefined
            assertParamExists('stopRecording', 'deviceSerial', deviceSerial)
            // verify required parameter 'sensorType' is not null or undefined
            assertParamExists('stopRecording', 'sensorType', sensorType)
            // verify required parameter 'save' is not null or undefined
            assertParamExists('stopRecording', 'save', save)
            const localVarPath = `/sensors/{deviceSerial}/{sensorType}/recording/stop`
                .replace(`{${"deviceSerial"}}`, encodeURIComponent(String(deviceSerial)))
                .replace(`{${"sensorType"}}`, encodeURIComponent(String(sensorType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (save !== undefined) {
                localVarQueryParameter['save'] = save;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} deviceSerial 
         * @param {Type} sensorType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopTransmission: async (deviceSerial: string, sensorType: Type, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceSerial' is not null or undefined
            assertParamExists('stopTransmission', 'deviceSerial', deviceSerial)
            // verify required parameter 'sensorType' is not null or undefined
            assertParamExists('stopTransmission', 'sensorType', sensorType)
            const localVarPath = `/sensors/{deviceSerial}/{sensorType}/transmission/stop`
                .replace(`{${"deviceSerial"}}`, encodeURIComponent(String(deviceSerial)))
                .replace(`{${"sensorType"}}`, encodeURIComponent(String(sensorType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SensorControllerApi - functional programming interface
 * @export
 */
export const SensorControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SensorControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} deviceSerial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSensorStatus(deviceSerial: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SensorStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSensorStatus(deviceSerial, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SensorControllerApi.getSensorStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} deviceSerial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startRecording(deviceSerial: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startRecording(deviceSerial, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SensorControllerApi.startRecording']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} deviceSerial 
         * @param {Type} sensorType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startTransmission(deviceSerial: string, sensorType: Type, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startTransmission(deviceSerial, sensorType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SensorControllerApi.startTransmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} deviceSerial 
         * @param {Type} sensorType 
         * @param {boolean} save 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stopRecording(deviceSerial: string, sensorType: Type, save: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stopRecording(deviceSerial, sensorType, save, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SensorControllerApi.stopRecording']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} deviceSerial 
         * @param {Type} sensorType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stopTransmission(deviceSerial: string, sensorType: Type, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stopTransmission(deviceSerial, sensorType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SensorControllerApi.stopTransmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SensorControllerApi - factory interface
 * @export
 */
export const SensorControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SensorControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} deviceSerial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorStatus(deviceSerial: string, options?: any): AxiosPromise<SensorStatus> {
            return localVarFp.getSensorStatus(deviceSerial, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} deviceSerial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startRecording(deviceSerial: string, options?: any): AxiosPromise<void> {
            return localVarFp.startRecording(deviceSerial, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} deviceSerial 
         * @param {Type} sensorType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startTransmission(deviceSerial: string, sensorType: Type, options?: any): AxiosPromise<void> {
            return localVarFp.startTransmission(deviceSerial, sensorType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} deviceSerial 
         * @param {Type} sensorType 
         * @param {boolean} save 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopRecording(deviceSerial: string, sensorType: Type, save: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.stopRecording(deviceSerial, sensorType, save, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} deviceSerial 
         * @param {Type} sensorType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopTransmission(deviceSerial: string, sensorType: Type, options?: any): AxiosPromise<void> {
            return localVarFp.stopTransmission(deviceSerial, sensorType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SensorControllerApi - object-oriented interface
 * @export
 * @class SensorControllerApi
 * @extends {BaseAPI}
 */
export class SensorControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} deviceSerial 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorControllerApi
     */
    public getSensorStatus(deviceSerial: string, options?: RawAxiosRequestConfig) {
        return SensorControllerApiFp(this.configuration).getSensorStatus(deviceSerial, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} deviceSerial 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorControllerApi
     */
    public startRecording(deviceSerial: string, options?: RawAxiosRequestConfig) {
        return SensorControllerApiFp(this.configuration).startRecording(deviceSerial, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} deviceSerial 
     * @param {Type} sensorType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorControllerApi
     */
    public startTransmission(deviceSerial: string, sensorType: Type, options?: RawAxiosRequestConfig) {
        return SensorControllerApiFp(this.configuration).startTransmission(deviceSerial, sensorType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} deviceSerial 
     * @param {Type} sensorType 
     * @param {boolean} save 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorControllerApi
     */
    public stopRecording(deviceSerial: string, sensorType: Type, save: boolean, options?: RawAxiosRequestConfig) {
        return SensorControllerApiFp(this.configuration).stopRecording(deviceSerial, sensorType, save, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} deviceSerial 
     * @param {Type} sensorType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorControllerApi
     */
    public stopTransmission(deviceSerial: string, sensorType: Type, options?: RawAxiosRequestConfig) {
        return SensorControllerApiFp(this.configuration).stopTransmission(deviceSerial, sensorType, options).then((request) => request(this.axios, this.basePath));
    }
}

